import React, { useCallback, useEffect } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { unsubscribeEmail } from '@pepper/utils/src/api/misc/misc'

import { Button } from '../../atoms'
import { useShowMessage } from '../../providers'
import { RadioField } from '../../molecules'

import UnsubscribeImage from '../../assets/artwork_unsubscribe.png'

import styles from './_.module.css'

const validationSchema = Yup.object({
  reason: Yup.string().required('Please select a reason').nullable()
})

const options = [
  'I no longer wish to receive these e-mails',
  'These e-mails were irrelevant for me',
  'The emails no longer serve the content I originally subscribed for',
  'Spam or Inappropriate Content',
  'Other Reasons'
]

export const UnsubscribeEmail: React.FC = () => {
  const showMessage = useShowMessage()

  const handleUnsubscribeRequest = useCallback(
    async (reason?: string) => {
      const queryParams = new URLSearchParams(window.location.search)
      const token = queryParams.get('token')
      if (token) {
        const { status, error } = await unsubscribeEmail({ token, reason })
        if (status === 'ok') {
          showMessage({
            type: 'success',
            message: 'You have been unsubscribed from all the emails'
          })
        } else {
          showMessage({ type: 'error', message: error })
        }
      } else {
        alert('Invalid user')
      }
    },
    [showMessage]
  )

  useEffect(() => {
    handleUnsubscribeRequest()
  }, [handleUnsubscribeRequest])

  const handleSubmit = (values: { reason: string }) => {
    handleUnsubscribeRequest(values.reason)
  }

  return (
    <div className={styles.container}>
      <img
        className={styles.heroImage}
        src={UnsubscribeImage}
        alt="Sorry to see you go!"
      />
      <div>
        <h1 className={styles.title}>You have been unsubscribed</h1>
        <h2 className={styles.description}>
          You have successfully unsubscribed from these emails. Please take a
          moment to let us know why you unsubscribed:
        </h2>
        <hr className={styles.divider} />

        <Formik
          initialValues={{ reason: '' }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {(): React.ReactNode => {
            return (
              <Form>
                <RadioField
                  className={styles.radioItems}
                  name="reason"
                  fieldProps={{
                    options
                  }}
                />
                <Button type="primary" htmlType="submit" className={styles.cta}>
                  Share Feedback
                </Button>
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}
